import * as React from "react";
const SvgDraggable = (props) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 20 21"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m10 20.982-4.075-4.075 1.1-1.1 2.225 2.225v-4.725h1.5v4.725l2.225-2.225 1.1 1.1L10 20.982Zm-6.05-6.05L0 10.982l3.975-3.975 1.1 1.1-2.125 2.125h4.725v1.5H2.95l2.1 2.1-1.1 1.1Zm12.1 0-1.1-1.1 2.1-2.1h-4.7v-1.5h4.7l-2.1-2.1 1.1-1.1 3.95 3.95-3.95 3.95Zm-6.8-6.3v-4.7l-2.1 2.1-1.1-1.1L10 .982l3.95 3.95-1.1 1.1-2.1-2.1v4.7h-1.5Z"
      fill={props?.fill || "#091E42"}
    />
  </svg>
);
export default SvgDraggable;
